import { loader } from 'graphql.macro';
import { User } from '../../../../graphql-generate/graphql-types';
import graphQLClient from '../base';
const query = loader('../documents/queries/getViewer.gql');

interface IViewerRequestData {
  viewer: User
}

export default async function getViewer(): Promise<User> {
  const viewerRequest = await graphQLClient.request<IViewerRequestData>(query);
  return viewerRequest.viewer;
}
